module.exports = __webpack_public_path__ + "images/8cc3fc0609d1b13fd13123c0f5639443.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/jasmijn_thumb.jpg
// module id = 144
// module chunks = 24